export class BpmnDeploymentIdentifier {
  constructor(public processId: string, public deploymentId: string, public name: string) { }
}
